import {inlineError} from '@s-ui/decorators'

import {PageRepository} from './PageRepository.js'

/**
 * @class
 * @implements PageRepository
 */
export class EmptyPageRepository extends PageRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Function} deps.urlValueObjectFactory
   */
  constructor({urlValueObjectFactory}) {
    super()
    this._urlValueObjectFactory = urlValueObjectFactory
  }

  @inlineError
  async getCurrentUrl() {
    return this._urlValueObjectFactory({url: null})
  }
}
